import { FC, useState } from 'react';
import { translate } from '../../i18n';
import { cvvInputStyles } from './styles';

export interface CVVInputProps {
  value?: string;
  onChange?: (value: string) => void;
  onError?: (error?: string) => void;
  testID?: string;
  mode?: 'add' | 'edit';
}

/**
 * CVVInput — Input para código de seguridad con validación
 *
 * Cambios:
 * ✅ Estilos centralizados en styles.ts
 * ✅ i18n para label, placeholder, mensajes de error
 * ✅ Validación con mensajes dinámicos
 * ✅ Cero Tailwind, cero hardcodes
 */
export const CVVInput: FC<CVVInputProps> = ({
  value = '',
  onChange,
  onError,
  testID = 'cvv-input',
  mode = 'edit'
}) => {
  const [error, setError] = useState<string | undefined>();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value;
    // Solo permitir números, máximo 4 dígitos
    if (/^\d{0,4}$/.test(val)) {
      onChange?.(val);
      // Validación simple: CVV debe tener 3 o 4 dígitos
      if (val.length > 0 && (val.length < 3 || val.length > 4)) {
        const errorMsg = translate('paymentsUI.cvvInput.error');
        setError(errorMsg);
        onError?.(errorMsg);
      } else {
        setError(undefined);
        onError?.(undefined);
      }
    }
  };

  return (
    <div style={cvvInputStyles.container}>
      <label style={cvvInputStyles.label} htmlFor={testID}>
        {translate( mode === 'add' ? 'paymentsUI.cvvInput.label' : 'paymentsUI.cvvInput.editLabel')}
      </label>
      <input
        id={testID}
        type="password"
        placeholder={translate('paymentsUI.cvvInput.placeholder')}
        value={value}
        onChange={handleChange}
        maxLength={4}
        data-testid={testID}
        aria-label={translate('paymentsUI.cvvInput.ariaLabel')}
        style={{
          ...cvvInputStyles.input,
          ...(error && cvvInputStyles.inputError),
        }}
      />
      {error && <p style={cvvInputStyles.errorMessage}>{error}</p>}
    </div>
  );
};
